import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['permission_type']),
    $canEdit() {
      return this.permission_type === 'edit_and_view'
    },
  },
}
